goog.module('yext.developerapps.hubspotleadgen.init');
goog.module.declareLegacyNamespace();

const LeadGen = goog.require('yext.developerapps.common.LeadGen');

$(document).ready(function() {
  var initIdentifier = $('.js-hubspotleadgen-init').data('jsinit');
  switch (initIdentifier) {
    case 'leadgen':
      var data = $('.js-hubspotleadgen-init').data('json');
      new LeadGen(data);
      break;
  }
});

